import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { backend_domain } from "../../helpers";
import { userContext } from "../../context/UserContext";
import ProductCard from "../ProductCard";

const HomeRecommendSection = ({ homeData }) => {
  const { user, cartUpdate } = useContext(userContext);
  return (
    <section className="recommended mt-90 mb-90">
      {homeData?.product_sections?.length > 0 &&
        homeData?.product_sections?.map((item, index) => {
          return (
            <div className="container container-lg" key={index}>
              <div className="section-heading mb-0 mt-80 flex-between flex-wrap gap-16">
                <h5 className="mb-0">{item?.bundle_name}</h5>
              </div>

              <div className="row">
                {item?.items?.map((product, prod_index) => (
                  <ProductCard key={prod_index} product={product} cartUpdate={cartUpdate} user={user}  />
                ))}
              </div>
            </div>
          );
        })}
    </section>
  );
};

export default HomeRecommendSection;
